<script setup>
import { inject } from 'vue';
import { useCustomerStore } from '../store/customer';
import { getPrettyPrice } from '../shared/utils';

let rootData = inject('rootData');

// A short, up-front delivery hint per service so the choice isn't blind:
//   - Uber service  -> "Price after address" (live quote needs the address)
//   - flat-fee service -> e.g. "$5.00 delivery"
//   - free / pickup  -> nothing
// Reads the same _EZCL.data.services contract the cart store uses.
const deliveryHint = (key) => {
    const svc = window?._EZCL?.data?.services?.[key];
    if (!svc?.delivery) return '';
    if (svc.delivery.provider === 'uber_direct') return 'Price after address';
    const cents = Number(svc.cost);
    return Number.isFinite(cents) && cents > 0 ? `${getPrettyPrice(cents)} delivery` : '';
};
</script>

<template>
    <div class="orderType">
        <div class="orderTypeInner">
            <label v-if="Object.keys(rootData.services).length > 0" v-for="service, key in rootData.services" for="ordertype">
                <input
                    name="ordertype"
                    type="radio"
                    v-model="useCustomerStore().orderType"
                    v-bind="useCustomerStore().orderTypeProps"
                    :value="key"
                    :selected="useCustomerStore().orderType ? useCustomerStore().orderType == key : rootData.defaultService == key" />
                <div class="orderTypeContent">
                    <div class="orderTypeName" v-text="service.name"></div>
                    <div class="orderTypeInfo" v-text="service.note || deliveryHint(key)"></div>
                </div>
            </label>
            <label v-else class="orderTypeEmpty">
                <div class="orderTypeContent">
                    <div class="orderTypeName" v-text="'NO SERVICES ENABLED'"></div>
                    <div class="orderTypeInfo"></div>
                </div>
            </label>
        </div>
    </div>
</template>

<style lang="scss">
.orderType {
    width: 100%;
    position: relative;
    margin-bottom: 1.25rem;
    border-radius: var(--rounded-full);
    overflow: hidden;
    color: var(--text-primary);
    border: 3px solid var(--text-primary);
    min-height: 42px;
    padding: 2px;

    &Inner {
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;
        width: 100%;
        height: 100%;
        position: relative;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));

        label {
            cursor: pointer;
            -webkit-appearance: button;
            appearance: button;
            position: relative;
            user-select: none;
            overflow: hidden;
            flex: 1 0 50%;
            border-radius: var(--rounded-full);
            display: flex;
            align-items: stretch;
            align-content: center;

            &.orderTypeEmpty {
                cursor: initial;
                opacity: 0.75;
                .orderTypeContent {
                    background-color: #ccc;
                }
            }
        }
    }

    &Info {
        font-size: 0.75em;
        font-weight: 400;
        margin-top: 0.125em;
        line-height: 1.2;
        opacity: 0.75;
    }
    &Content {
        font-size: 0.875rem;
        font-weight: 500;
        display: block;
        text-align: center;
        background-color: #fff;
        padding: 0.375rem 0.5rem;
        border-radius: 9999px;
        border: 2px solid transparent;
        line-height: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    input[type="radio"] {
        opacity: 0.01;
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        opacity: 0;
        cursor: pointer;
        z-index: 3;
        line-height: 1;

        &:checked + .orderTypeContent {
            background-color: var(--c-primary);
            color: var(--c-primary-fg);

            // .orderTypeName {
            //     font-weight: 500;
            // }
        }
    }
}
</style>